import { select, call, put } from "redux-saga/effects";
import set from "lodash.set";

import { selectAccessToken } from "selector/authSelectors";
import {
  apiRequestSuccessAction,
  apiRequestFailureAction
} from "actions/requestActions";

export default function* fetchSaga(fn, args = {}, raw = false) {
  const token = yield select(selectAccessToken);

  const authArgs = { ...args };
  set(authArgs, "options.headers.Authorization", `Bearer ${token}`);

  const response = yield call(fn, authArgs);
  if (response.status >= 400) {
    yield put(apiRequestFailureAction(response.clone()));
    throw new Error(response.statusText);
  }
  yield put(apiRequestSuccessAction(response.clone()));

  if (raw) {
    return response;
  }

  return yield call(response.json.bind(response));
}

